import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import ChangePasswordContainer from './ChangePasswordContainer';
import { loadAccount } from '../../actions/account';

const title = 'Change Password';

export default async function action({ store }) {

  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  let accountData = store.getState().account?.data;
  if (!accountData || !accountData.userId) {
    await store.dispatch(loadAccount());
    accountData = store.getState().account?.data;
  }

  if (!accountData || !accountData.userId) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout showSideMenu={'accountMenu'}><ChangePasswordContainer title={title} /></UserLayout>,
  };
};
